module.exports = __webpack_public_path__ + "images/map/map-marker-active-6d21b30e019825b8e7c5c0b435c4562f.png";